import { axiosInstance as axios } from '../_utils';
import config from '../store/_config';

export const axiosReadTagCart = (id) => {
    let { url, query } = config.cart.readTag;
    query = query.replace(/{params}/, `ID: ${id}`);

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};